import React, { useMemo, useState } from "react";
import "./App.css";
import Main from "./containers/Main";
import { ThemeProvider } from "styled-components";
import { samerGoldLightTheme, samerGoldTheme } from "./theme";
import { GlobalStyles } from "./global";
import { ThemeModeContext } from "./themeMode";
import { getInitialLanguage, LanguageContext, setActiveLanguage } from "./i18n";

function App() {
  const [themeMode, setThemeMode] = useState(() => {
    const savedTheme = localStorage.getItem("samer-theme");
    return savedTheme === "dark" ? "dark" : "light";
  });
  const [language, setLanguage] = useState(() => {
    const initialLanguage = getInitialLanguage();
    setActiveLanguage(initialLanguage);
    return initialLanguage;
  });

  const languageContext = useMemo(
    () => ({
      language,
      direction: language === "ar" ? "rtl" : "ltr",
      toggleLanguage: () => {
        const nextLanguage = language === "ar" ? "en" : "ar";
        setActiveLanguage(nextLanguage);
        setLanguage(nextLanguage);
      },
    }),
    [language]
  );

  const theme = themeMode === "light" ? samerGoldLightTheme : samerGoldTheme;
  const themeModeContext = useMemo(
    () => ({
      mode: themeMode,
      toggleTheme: () => {
        const nextTheme = themeMode === "dark" ? "light" : "dark";
        localStorage.setItem("samer-theme", nextTheme);
        setThemeMode(nextTheme);
      },
    }),
    [themeMode]
  );

  return (
    <LanguageContext.Provider value={languageContext}>
      <ThemeModeContext.Provider value={themeModeContext}>
        <ThemeProvider theme={theme}>
          <>
            <GlobalStyles />
            <div>
              <Main theme={theme} />
            </div>
          </>
        </ThemeProvider>
      </ThemeModeContext.Provider>
    </LanguageContext.Provider>
  );
}

export default App;
